import { styled } from '@mui/material/styles'
import { Box } from '@mui/material'

const OrderModalContainer = styled(Box)`
  position: relative;
  min-height: 300px;

  &.loading {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  span.status {
    position: absolute;
    right: 30px;
    top: 0px;
    color: white;
  }

  .detail-tabs {
    margin-top: 50px;
  }

  .supplier-label {
    &:hover {
      cursor: pointer;
    }
  }
`

export default OrderModalContainer
